<template>
    <div style="width: 100%;background:#fff;">
        <div class="head-top">
            <el-button class="layui-btn layui-btn-primary" @click="goBack()" style="border: 0;color: #4D7BF4;">返回</el-button>
            <el-breadcrumb separator="/" style="margin-left:20px;">
                <el-breadcrumb-item :to="{ path: '/progress' }">进度管理</el-breadcrumb-item>
                <el-breadcrumb-item>{{plan.planName}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="layui-row secondCon userCon" style="height: calc( 100vh - 160px );">
            <div class="layui-col-lg12" style="height:100%;overflow: auto;">
                <form class="layui-form selectForm" style="height:105px;">
                    <el-col :span="20" style="text-align: left;padding-left: 20px;">
                        <p class="dute-title">施工计划描述</p>
                        <p class="desc">
                            {{plan.planDescribe}}
                        </p>
                    </el-col>
                    <el-col :span="4" style="text-align: right;margin-top: 8px;display: flex;justify-content: flex-end;padding-right: 20px;">
                        <el-button class="layui-btn" @click="addDute" style="background: #4D7BF4;color:#fff;">进度提报</el-button>
                    </el-col>
                </form>
                <div class="build-table">
                    <el-table
                        :default-sort="{prop: 'date', order: 'descending'}"
                        :data="tableDataEnd"
                        height="100%"
                        border
                        style="width: 100%;"
                        >
                        <template slot="empty">
                            <p>{{dataText}}</p>
                        </template>
                        <el-table-column
                            label="序号"
                            type="index"
                            width="60">
                        </el-table-column>
                        <el-table-column label="提报时间" sortable>
                            <template slot-scope="scope">
                                <a>{{ scope.row.actualStartTime}}</a>
                            </template>
                        </el-table-column>
                        <el-table-column label="提报人">
                            <template slot-scope="scope">
                                <span>{{ scope.row.mentionUserid }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="提交进度">
                            <template slot-scope="scope">
                                <el-progress :text-inside="true" :stroke-width="18" :percentage="scope.row.completedProgress"></el-progress>
                            </template>
                        </el-table-column>
                        <el-table-column label="进度汇报">
                            <template slot-scope="scope">
                                <span>{{ scope.row.progressReport }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="附件">
                            <template slot-scope="scope">
                                <a class="layui-table-link" v-for="item in scope.row.files" :key="item"  :href="filePath+item.url" target="_blank">{{item.name}}</a>
                            </template>
                        </el-table-column>

                        <!-- 新增窗口 -->
                        <el-dialog
                            :title="dialogTitle"
                            :visible.sync="addFormVisible"
                            center
                            :append-to-body="true"
                            :lock-scroll="false"
                            width="500px"
                            class="add-form"
                        >
                            <el-form :model="addForm" ref="addForm" label-width="100px" :label-position="labelPosition" >
                                <el-form-item label="工序名称：" required>
                                    <el-input type="textarea" placeholder="输入内容" v-model="addForm.progressReport"></el-input>
                                </el-form-item>
                                <el-form-item label="计划附件">
                                    <el-upload
                                        class="upload-demo"
                                        :action="uploadUrl"
                                        :headers="uploadHead"
                                        :data={type:205}
                                        :on-change="handleChange"
                                        :file-list="fileList">
                                        <el-button size="small" type="primary">点击上传</el-button>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="本期完成" required>
                                    <div class="block">
                                        <el-slider
                                        v-model="addForm.completedProgress"
                                        show-input>
                                        </el-slider>
                                    </div>
                                </el-form-item>
                            </el-form>
                            <div slot="footer" class="dialog-footer">
                                <el-button @click="addFormVisible = false">取 消</el-button>
                                <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
                            </div>
                        </el-dialog>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import myHttp from '../../untils/port';
import util from "../../untils/util.js"
import base from '../../untils/base'
export default {
    data(){
        return{
            id:'',
            filePath:base.httpCtx,
            plan:{
                planName:'',
                planDescribe:''
            },
            labelPosition:'top',
            addFormVisible:false,
            addForm:{
                progressReport:'',
                completedProgress:0,
                attachment:'',
                mentionUserid:this.$store.state.user.id,
                parentId:'',
            },
            dialogTitle:"进度提报",
            tableDataEnd:[],//表格列表
            fileList:[],//上传附件列表
            uploadUrl:base.url+"/upload/uploadPhoto",//上传地址
            uploadHead:{  //上传接口header参数
                accessToken:this.$store.state.token
            },
            dataText:'数据加载中...',
            prevTess : 0,//当前进度
        }
    },
    mounted(){
        this.id = this.$route.params.id;
        this.addForm.parentId = this.id;
        this.getData()
        this.getProgress()
    },
    methods:{
        getData(){
            var that = this;
            this.curPlanDay = 0;
            this.allPlanDay = 0;
            myHttp.getNode({
                id:this.id
            }).then(function(resp){
                if(resp.data.code=="200"){
                    var list = resp.data.data.progress||[];
                    for(var i=0;i<list.length;i++){
                        list[i].completedProgress = list[i].completedProgress==''?0:list[i].completedProgress;
                        if(undefined==list[i].attachment||list[i].attachment==""){
                            list[i].files = [];
                        }else{
                            if(util.common.isJSON(list[i].attachment)){
                                list[i].files = JSON.parse(list[i].attachment);
                            }else{
                                list[i].files = [];
                            }
                        }
                    }
                    that.tableDataEnd = list;
                    if(list.length==0){
                        that.dataText = '暂无数据'
                    }
                    var plan = resp.data.data.frist[0];
                    that.plan = plan;
                }else{
                    that.dataText = '暂无数据'
                }
            });
        },
        //获取计划进度
        getPlanProgress(s1,s2){
            var result = 0;
            if(new Date().getTime()>=new Date(s1).getTime()&&new Date().getTime()<new Date(s2).getTime()){
                result = util.myTime.getdayByDate(s1,new Date())+1;
            }else if(new Date().getTime()>=new Date(s2).getTime()){
                result = util.myTime.getdayByDate(s1,s2)+1;
            }
            var all = util.myTime.getdayByDate(s1,s2)+1;
            return parseFloat(((result/all)*100).toFixed(2));
        },
        //添加
        sumbitAddRow(formName){
            var that = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if(parseFloat(that.addForm.completedProgress)<=parseFloat(that.prevTess)){
                        that.$message.error('输入进度必须大于当前进度！');
                        return;
                    }
                    var list = that.fileList;
                    var accList = [];
                    for(var i=0;i<list.length;i++){
                        var obj = {name:'',url:''};
                        obj.name = list[i].name;
                        obj.url = list[i].response.data.saveUrls;
                        accList.push(obj);
                    }
                    that.addForm.attachment = JSON.stringify(accList);
                    myHttp.getAddUpdateReport(that.addForm).then(function(resp){
                        if(resp.data.code=="200"){
                            that.$message.success("添加成功");
                            that.addFormVisible = false;
                            that.getData();
                        }else{
                            that.$message.error(resp.data.msg);
                        }
                    });
                }
            });
        },
        //新增
        addDute(){
            this.addForm={
                progressReport:'',
                completedProgress:0,
                attachment:'',
                mentionUserid:this.$store.state.user.id,
                parentId:this.addForm.parentId
            }
            this.addFormVisible = true;
            this.getProgress()
        },
        //监听上传附件改变
        handleChange(file, fileList) {
            this.fileList = fileList;
        },
        //获取已经完成的进度
        getProgress(){
            var that = this;
            myHttp.getcompletedProgress({
                id:this.id
            }).then(function(resp){
                if(resp.data.code=="200"){
                    var str = resp.data.data.progress.length>0?resp.data.data.progress[0].completedProgress||0:0;
                    that.prevTess = parseFloat(str)
                    that.addForm.completedProgress = parseFloat(str)
                }
            });
        },
        //返回
        goBack(){
            this.$router.go(-1);
        }
        
    }
}
</script>
<style scoped>
    .table_wrapper{
        display:flex;
        flex-wrap: wrap;
        padding: 0;
        height: calc( 100vh - 316px );
    }
    .layui-layer-title{
        text-align: center;
        padding: 0 20px;
    }
    #qualityAdd .layui-form-label{
        text-align: left;
        padding-left: 0;
    }
    #qualityAdd .layui-input-block{
        margin-left: 0;
    }
    #qualityAdd .layui-input-inline{
        min-width: 180px;
    }
    .head-top{
        width: 100%;
        height: 70px;
        box-sizing: border-box;
        padding: 0 20px;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        background: #fff;
        border-bottom: 1px solid #ddd;
    }
    .dute-title{
        font-size: 18px;
        font-weight: bold;
        color: #707070;
    }
    .desc{
        padding: 10px;
        height: 60px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        line-height: 24px;
        color: #707070;
    }
    .layui-table-link{
        cursor: pointer;
    }
    .build-table{
        height: calc( 100% - 110px );
        padding: 0 20px;
    }
    p{
        margin: 0;
        padding: 0;
    }
</style>
